/* Version: 3.5.155 */
'use client';
import { useContext, createContext } from 'react';

var OptionContext = /*#__PURE__*/createContext({
  labelProps: {},
  descriptionProps: {}
});
var useOptionContext = function useOptionContext() {
  var context = useContext(OptionContext);
  return context;
};

export { OptionContext as default, useOptionContext };
